import StatusBadge from "../components/StatusBadge";

function formatLeagueMeta(selectedLeague) {
  if (!selectedLeague) return "Open competitions and active brackets";

  const parts = [];
  if (selectedLeague.mode) parts.push(String(selectedLeague.mode).replace(/_/g, " "));
  if (selectedLeague.format) parts.push(String(selectedLeague.format).replace(/_/g, " "));
  if (selectedLeague.entry_type) parts.push(String(selectedLeague.entry_type).replace(/_/g, " "));
  return parts.join(" | ");
}

function LeaguePage({
  title = "Leagues",
  description = "Track competitions that are live now or currently taking registrations.",
  metricsNode = null,
  gateNode = null,
  message = "",
  error = "",
  tabsNode = null,
  railNode = null,
  mainNode = null,
  selectedLeague = null,
  featuredLeagues = [],
}) {
  const featuredLeague = selectedLeague || featuredLeagues[0] || null;

  return (
    <section className="appRoutePage leagueRoutePage">
      <div className="routePageHeader leaguePageHeader">
        <div className="leaguePageHero">
          <div className="leaguePageHeroMark" aria-hidden="true">{"\u2655"}</div>
          <div className="leaguePageHeroCopy">
            <span className="leaguePageEyebrow">{title}</span>
            <h1>{title}</h1>
            <p>{featuredLeague?.description || description}</p>
            <div className="leaguePageHeroMeta">
              {featuredLeague?.name ? <span>{featuredLeague.name}</span> : null}
              <span>{formatLeagueMeta(featuredLeague)}</span>
              {featuredLeague ? <StatusBadge status={featuredLeague.status} /> : null}
              {featuredLeague?.current_team_count || featuredLeague?.max_teams ? (
                <span>
                  {featuredLeague.current_team_count || 0}/{featuredLeague.max_teams || 0} teams
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {metricsNode}
      {gateNode}
      {message ? <p className="successMessage">{message}</p> : null}
      {error ? <p className="errorMessage">{error}</p> : null}
      {tabsNode}
      <div className="leagueRouteShell leagueOverviewShell">
        <aside className="leagueRouteRail">{railNode}</aside>
        <div className="leagueRouteMain leagueRouteStage">{mainNode}</div>
      </div>
    </section>
  );
}

export default LeaguePage;
